<div class="modal-header px-4">
    <h4 class="modal-title header-5">
        {{ title }}
    </h4>
    <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="Close"
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button></div>

<div class="modal-body pt-0 mt-3 w-100 mx-0">
    @if(loader?.isLoading) {
        <div class="v-center loader-wrapper">
            <app-loading [text]="loader.text"></app-loading>
        </div>
    }@else {
        <app-zorro-table 
        *ngIf="tableData.rows?.length"
        tableId="table-view-modal"
        class="w-100"
        [columns]="tableData.columns"
        [data]="tableData.rows"
        [options]="{ pageSize: 10, showPagination: true }"
        (handleActions)="handleTableActions($event)"
        ></app-zorro-table>
        <div [hidden]="tableData.rows?.length" class="v-center loader-wrapper">
            <app-no-data></app-no-data>
        </div>
    }
</div>